import { Tooltip } from "@mui/material";
import { AlterarTemp, Props, Temperatura } from "./utils";
import { useState } from "react";
import loadingSvg from "./loader.svg";
import ClearIcon from "@mui/icons-material/Clear";
import { Container, Temp } from "./styles";
import { useToast } from "../../../../hooks/ToastContext";

export function TempChanger({ idCard, temperatura, onChange }: Props) {
  const { showToast } = useToast();
  const [loading, setLoading] = useState<boolean>(false);

  async function handleChange(temperaturaParam: Temperatura) {
    setLoading(true);
    const response = await AlterarTemp({
      idCard,
      temperatura: temperaturaParam === temperatura ? "" : temperaturaParam,
    });
    if (response === 200) {
      showToast("success", "Temperatura definida, atualizando tabela");
      if (onChange) onChange();
    } else {
      showToast("error", "Erro ao mudar a temperatura");
    }
    setLoading(false);
  }
  return (
    <>
      <Container>
        {loading ? (
          <img src={loadingSvg} alt="" width={75} height={23} />
        ) : (
          ["Frio", "Morno", "Quente"].map((item) => (
            <Tooltip title={item} placement="top">
              <Temp
                temperature={item as "Frio" | "Morno" | "Quente"}
                selected={item === temperatura}
                onClick={(e) => {
                  e.stopPropagation();
                  handleChange(item as "Frio" | "Morno" | "Quente");
                }}
              >
                <ClearIcon />
              </Temp>
            </Tooltip>
          ))
        )}
      </Container>
    </>
  );
}
